import { matchPath, useLocation } from 'react-router-dom';

import { UserRoles } from '@shared/types/auth';

import { prepareUrl } from 'src/utils/routerHelpers';
import { routesPath } from 'src/router/routes';
import { useParams } from 'src/hooks/useParams';
import { useAuthSlice } from '@restore/auth/auth.slice';
import { getAllRoutesByRole } from 'src/utils/routeHelpers';

export const detectIsViewerByUrl = (
  clinicalTrialId: string,
  taskId: string,
  userRole?: UserRoles | null,
  pathname: string = location.pathname
) => {
  // Use role-based routes or fallback to reader routes
  const roleRoutes = userRole
    ? getAllRoutesByRole(userRole)
    : {
        taskViewer: routesPath.readerTaskViewer,
        taskViewerDetached: routesPath.readerTaskViewerDetached,
        subTaskViewer: routesPath.readerSubTaskViewer,
        subTaskViewerDetached: routesPath.readerSubTaskViewerDetached,
      };

  const taskViewerUrls = [
    prepareUrl(roleRoutes.taskViewer, [clinicalTrialId, taskId]),
    prepareUrl(roleRoutes.taskViewerDetached, [clinicalTrialId, taskId]),
  ];

  if (taskViewerUrls.includes(pathname)) {
    return true;
  }

  return [roleRoutes.subTaskViewer, roleRoutes.subTaskViewerDetached].some(
    route => {
      const match = matchPath(route, pathname);

      return (
        match?.params.id === clinicalTrialId && match.params.taskId === taskId
      );
    }
  );
};

export const useDetectIsViewerByUrl = (): boolean => {
  const { id: clinicalTrialId, taskId } = useParams();
  const { pathname } = useLocation();
  const userData = useAuthSlice(s => s.data);

  return detectIsViewerByUrl(
    clinicalTrialId,
    taskId,
    userData?.selectedRole,
    pathname
  );
};
